
import { Component, Prop, Vue } from 'vue-property-decorator';
import { WebsiteComposite } from '@/services/Website/interfaces';

@Component
export default class WpInstallPanel extends Vue {
  @Prop({ type: Object, required: true })
  public composite!: WebsiteComposite;

  @Prop({ type: Boolean, default: false })
  public busy!: boolean;

  @Prop({ type: String, default: '' })
  public errorMessage!: string;

  public title = '';

  public user = '';

  public password = '';

  public email = '';

  public directory = '';

  public forceInstall = false;

  public get domain(): string {
    return this.composite.website.domain;
  }

  public get valid(): boolean {
    return !!this.title.trim() && !!this.user.trim() && !!this.password.trim() && !!this.email.trim();
  }

  public onSubmit(): void {
    if (!this.valid) {
      return;
    }

    const payload: {
      title: string;
      user: string;
      password: string;
      email: string;
      forceInstall: boolean;
      directory?: string;
    } = {
      title: this.title.trim(),
      user: this.user.trim(),
      password: this.password,
      email: this.email.trim(),
      forceInstall: this.forceInstall,
    };

    if (this.directory.trim()) {
      payload.directory = this.directory.trim();
    }

    this.$emit('submit', payload);
  }
}
